<kendo-chart [seriesColors]="type == 'column' ? columnSeriesColors : lineSeriesColors"
  *ngIf="!isInputReceived || dataSet.length > 0">

  <kendo-chart-value-axis *ngIf="type == 'column'">
    <kendo-chart-value-axis-item [labels]="valueAxisLabels" [max]="maxValue" [majorUnit]="majorUnit">
    </kendo-chart-value-axis-item>
  </kendo-chart-value-axis>

  <kendo-chart-series>

    <kendo-chart-legend [visible]="legendVisibiltyStatus" position="top" orientation="horizontal"></kendo-chart-legend>

    <div *ngFor="let data of dataSet">
      <kendo-chart-series-item [stack]="true" *ngIf="data.type == 'column'" type="column" name="{{data.name}}"
        [spacing]="columnSpacing"  [gap]="columnGap" [data]="data.data" field="value" categoryField="label" [labels]="seriesLabels">
        <kendo-chart-series-item-tooltip>
          <ng-template let-dataItem="dataItem">
            <span *ngIf="dataItem?.tooltip" [innerHTML]="dataItem?.tooltip"></span>
          </ng-template>
        </kendo-chart-series-item-tooltip>
      </kendo-chart-series-item>

      <kendo-chart-series-item *ngIf="data.type == 'line'" type="line" name="{{data.name}}" [spacing]="0"
        [data]="data.data" field="value" categoryField="label" [labels]="historicalSeriesLabels">
        <kendo-chart-series-item-tooltip>
          <ng-template let-dataItem="dataItem">
            <span *ngIf="dataItem?.tooltip" [innerHTML]="dataItem?.tooltip"></span>
          </ng-template>
        </kendo-chart-series-item-tooltip>
      </kendo-chart-series-item>
    </div>
  </kendo-chart-series>

  <kendo-chart-category-axis>
    <kendo-chart-category-axis-item [majorGridLines]="{visible: false}"
                                    [labels]="type === 'column' ? columnAxisLabels : lineAxisLabels">
    </kendo-chart-category-axis-item>
  </kendo-chart-category-axis>
</kendo-chart>

<div *ngIf="isInputReceived && dataSet.length == 0">
  <p class="empty-graph-msg">
    No data available for the selected criteria.
  </p>
</div>
